import { render, staticRenderFns } from "./IpRangesTabPublic.vue?vue&type=template&id=397e2b5e&scoped=true&"
import script from "./IpRangesTabPublic.vue?vue&type=script&lang=js&"
export * from "./IpRangesTabPublic.vue?vue&type=script&lang=js&"
import style0 from "./IpRangesTabPublic.vue?vue&type=style&index=0&id=397e2b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e2b5e",
  null
  
)

export default component.exports